import { Button, ModalContent, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";

interface NoPlayersProps {
    onClose: () => void;
}

const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    textAlign: "center",
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

const NoPlayers = (props: NoPlayersProps) => {
    const { onClose } = props;

    const className = "kms-ds-share-modal-no-players";

    return (
        <StyledModalContent className={className}>
            <Typography variant={"body1"}>
                {translate(
                    "Seems like the site administrator did not setup players. Please contact your administrator to add v7 players for the embed options."
                )}
            </Typography>

            <StyledButton onClick={onClose}>{translate("Got It!")}</StyledButton>
        </StyledModalContent>
    );
};

export default NoPlayers;
